const Query = props => {
  const { consignmentsV2 } = props || {};
  const { sqlQuery } = consignmentsV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
